import { api } from '@api'
import { Driver } from '@types'

interface CreateDriverResponse {
  result: Driver
}

const createDriver = async (payload: Driver) => {
  const response = await api.post<CreateDriverResponse>('/drivers', { driver: payload })

  return response.data.result
}

export const DriversApi = { createDriver }
